import {stringify} from 'query-string'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/observable/dom/ajax'
import 'rxjs/add/operator/catch'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mergeMap'
import {Observable} from 'rxjs/Observable'
import * as App from '../app'
import * as RootConstants from '../constants'
import {ApplicationState} from '../rootReducer'
import * as Constants from './constants'
import * as Types from './types'

export const makeUrl = (options: Types.RequestOptions) => options.params ?
  `${options.url}?${stringify(options.params)}` : options.url

export const requestHandler = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {localStorage}: App.Dependencies,
) => action$.filter((action) => action.type.endsWith(Constants.REQUEST))
  .filter((action) => !action.type.includes(Constants.RASA_API))
  .filter((action) => !action.type.startsWith(Constants.SWITCH))
  .mergeMap((action: Types.RequestAction) =>
    Observable.ajax({
      body: action.options.payload,
      crossDomain: true,
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem(RootConstants.ACCESS_TOKEN),
        'Content-Type': 'application/json',
      },
      method: action.options.method,
      responseType: 'json',
      url: getUrl(store, action),
    }).map((payload: any)  =>
        ({type: action.type.replace(Constants.REQUEST, Constants.SUCCESS), payload, requestAction: action}))
      .catch((error: Error): Types.ErrorAction[] =>
        [({type: action.type.replace(Constants.REQUEST, Constants.ERROR), payload: {error}, requestAction: action})]),
  )

const getUrl = (store: Redux.Store<ApplicationState>, action: Types.RequestAction) => {
  let baseUrl = store.getState().config.api.origin
  if (action.type.includes(Constants.RASA_INTEGRATIONS_API)) {
    baseUrl = store.getState().config.integrationsApi.origin
  }
  return baseUrl + makeUrl(action.options)
}

export const switchedRequestHandler = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {localStorage}: App.Dependencies,
) => action$.filter((action) => action.type.endsWith(Constants.REQUEST))
  .filter((action) => !action.type.includes(Constants.RASA_API))
  .filter((action) => action.type.startsWith(Constants.SWITCH))
  .switchMap((action: Types.RequestAction) =>
    Observable.ajax({
      body: action.options.payload,
      crossDomain: true,
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem(RootConstants.ACCESS_TOKEN),
        'Content-Type': 'application/json',
      },
      method: action.options.method,
      responseType: 'json',
      url: getUrl(store, action),
    }).map((payload: any)  =>
        ({type: action.type.replace(Constants.REQUEST, Constants.SUCCESS), payload, requestAction: action}))
      .catch((error: Error): Types.ErrorAction[] =>
        [({type: action.type.replace(Constants.REQUEST, Constants.ERROR), payload: {error}, requestAction: action})]),
  )

export const rasaApi = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
) => action$.filter((action) => action.type.endsWith(Constants.REQUEST))
  .filter((action) => action.type.includes(Constants.RASA_API))
  .mergeMap((action: Types.RequestAction) =>
    Observable.ajax({
      body: action.options.payload,
      crossDomain: true,
      headers: {
        'Content-Type': 'application/json',
        'rasa-token': store.getState().config.rasaApi.url,
      },
      method: action.options.method,
      responseType: 'json',
      url: store.getState().config.rasaApi.url + makeUrl(action.options),
    }).map((payload: any): Types.SuccessAction =>
        ({type: action.type.replace(Constants.REQUEST, Constants.SUCCESS), payload, requestAction: action}))
      .catch((error: Error): Types.ErrorAction[] =>
        [({type: action.type.replace(Constants.REQUEST, Constants.ERROR), payload: {error}, requestAction: action})]),
  )

export const epic = ReduxObservable.combineEpics(
  requestHandler,
  switchedRequestHandler,
)



// WEBPACK FOOTER //
// ./src/request/epic.ts